import {
  type DetailedHTMLProps,
  forwardRef,
  type SelectHTMLAttributes,
} from 'react';

import clsx from 'clsx';

import { FloatingLabel } from './InputFilter';

const SelectFilter = forwardRef<
  HTMLSelectElement,
  DetailedHTMLProps<
    SelectHTMLAttributes<HTMLSelectElement>,
    HTMLSelectElement
  > & {
    label?: string;
    /**@deprecated */
    isOnModal?: boolean;
    innerClassName?: string;
    labelClassName?: string;
    labelSize?: 'sm' | 'xs' | 'md';
    requiredMark?: boolean;
  }
>(function SelectFilter(
  {
    label,
    labelSize = 'xs',
    className,
    children,
    isOnModal,
    innerClassName,
    labelClassName,
    requiredMark,
    ...props
  },
  ref
) {
  return (
    <div
      className={clsx(
        'outline-brand relative rounded outline-1 focus-within:outline',
        className
      )}
    >
      <select
        className={clsx(
          `dark:text-gray-light peer h-full w-full min-w-0 rounded border border-gray-200
          bg-white p-2 focus:outline-none disabled:bg-gray-100 disabled:text-gray-500
          dark:disabled:bg-gray-700 dark:disabled:text-gray-400`,
          // isOnModal class
          // PWA style has changed enough that this class should apply to all
          'dark:border-zinc-500 dark:bg-gray-600 dark:disabled:border-gray-600',
          innerClassName
        )}
        {...props}
        ref={ref}
      >
        {children}
      </select>
      {label && (
        <FloatingLabel
          isOnModal={isOnModal}
          size={labelSize}
          label={label}
          htmlFor={props.id}
          className={labelClassName}
          required={requiredMark}
        />
      )}
    </div>
  );
});

export { SelectFilter };
